const fixtures = /* @__PURE__ */ new Set();
function createFixtureSync(html, options) {
  const trimmed = html.trim();
  if (!trimmed) {
    throw new Error("createFixtureSync: HTML string must not be empty");
  }
  const temp = document.createElement("div");
  temp.innerHTML = trimmed;
  const element = temp.firstElementChild;
  if (!element) {
    throw new Error("createFixtureSync: HTML string produced no element");
  }
  if (options?.attributes) {
    for (const [name, value] of Object.entries(options.attributes)) {
      element.setAttribute(name, value);
    }
  }
  const container = options?.container ?? document.body;
  container.appendChild(element);
  fixtures.add(element);
  return element;
}
async function createFixture(html, options) {
  const element = createFixtureSync(html, options);
  return Promise.resolve(element);
}
function cleanupFixtures() {
  fixtures.forEach((el) => el.remove());
  fixtures.clear();
}
export {
  cleanupFixtures,
  createFixture,
  createFixtureSync
};
//# sourceMappingURL=fixture.js.map
